import { CSS_COLOR_TO_RGBA_MAP } from 'utils/colors';

import { TextOverlayV2 } from '../types';

const textColorMigration = (overlay: TextOverlayV2): TextOverlayV2 => {
  return overlay.withMutations(s => {
    const containerStyleColor =
      CSS_COLOR_TO_RGBA_MAP[s.getIn(['containerStyle', 'color'])];
    const textEditorStyleColor =
      CSS_COLOR_TO_RGBA_MAP[s.getIn(['editor', 'textStyle', 'color'])];

    // if the container styles contain a css color, it is replaced with the
    // rgba one.
    if (containerStyleColor) {
      s.setIn(['containerStyle', 'color'], containerStyleColor);
    }

    // If the text editor styles contain a css color, it is replaced with the
    // rgba one
    if (textEditorStyleColor) {
      s.setIn(['editor', 'textStyle', 'color'], textEditorStyleColor);
    }

    return s;
  });
};

export default textColorMigration;
